import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";
import { useStylesLbl,useStylesAutoSafe
} from '../../../../St/Reports/UseStyle';

export default function IntermediateAccHead(props) {
    const {
        branches,
        rptParams,
        onChangeAutoData, 
    } = props;

    const { t } = useTranslation(["forms"]);
    const claslbl = useStylesLbl();
    const clasASafe = useStylesAutoSafe();

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>

                <Grid item lg={3} md={3} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.branch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("branch", newValue);
                        }}
                        id="combo-box-demo"
                        size="small"
                        options={branches}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }

                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("branch")}
                                variant="outlined"
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            />
                        )}

                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
